/**
 * Returns the scheduled visits in which an activity has an instance, preserving
 * schedule and visit order from the SOA.
 */
export const getActivityVisitOptions = (study, activity) => {
    return Object.values(study.timelineInfo).flatMap((timeline) => (study.visitSchedule[timeline.id] ?? []).flatMap((visitId) => {
        const visit = study.getVisitById(timeline.id, visitId);
        if (!visit?.isScheduled || !visit.getActivitySequenceByActivityId(activity.id)) {
            return [];
        }
        return [{ label: visit.name, value: visit.id }];
    }));
};
/**
 * A specific visit can no longer remain selected after that activity instance
 * or visit is removed. Falling back to Any visit keeps the activity valid and
 * matches the legacy completion behavior.
 */
export const resetSpecificVisitScope = (study, visitId, activityId) => {
    study.getAllActivities().forEach((activity) => {
        if (activity.visitScope === 'specific_visit' &&
            activity.visitScopeEncounterId === visitId &&
            (!activityId || activity.id === activityId)) {
            activity.visitScope = 'any_visit';
        }
    });
};
